
import React from 'react';

import Repos from './Repos';

export default () => (
  <div>
    <p>
      An app that maps your favorite meet ups from meetup.com.
    </p>

    <p>
      <Repos repos={[{
        href: 'https://github.com/michael-software-engr/map_my_meetups',
        text: 'michael-software-engr/map_my_meetups'
      }]} />
    </p>

    Stack:
    <ul>
      <li><a href="http://rubyonrails.org/">Ruby on Rails</a></li>
      <li><a href="https://getbootstrap.com/">Bootstrap</a></li>
      <li><a href="https://jquery.com/">jQuery</a></li>
      <li><a href="http://rspec.info/">RSpec</a></li>
      <li><a href="https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API">Websockets</a></li>
    </ul>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/projects/descriptions/MMMU.js